export interface PaymentNetwork {
    code: string;
    label: string;
    logo: string;
    mode: string;
    isMobileMoney: boolean;
    contexts?: string[];
}

export const constants={
     MANAGED_COUNTRIES:[
    {
        isoCode2:"CI",
        name:"Cote D'ivoire"
    },
    

    {
        isoCode2:"SN",
        name:"Sénégal"
    }
],
 PaymentModes: [
        {
            code: 'WALLET',
            name: 'mobile money'
        },
        {
            code: 'CARD',
            name: 'carte'
        },
        {
            code: 'BANK',
            name: 'Compte bancaire'
        },
        {
            code: 'CASH',
            name: 'Espèces'
        }

    ],

 ALL_CONTRIES:[
  { "isoCode2": "AF", "name": "Afghanistan" },
  { "isoCode2": "ZA", "name": "Afrique du Sud" },
  { "isoCode2": "AL", "name": "Albanie" },
  { "isoCode2": "DZ", "name": "Algérie" },
  { "isoCode2": "DE", "name": "Allemagne" },
  { "isoCode2": "AD", "name": "Andorre" },
  { "isoCode2": "AO", "name": "Angola" },
  { "isoCode2": "AI", "name": "Anguilla" },
  { "isoCode2": "AQ", "name": "Antarctique" },
  { "isoCode2": "AG", "name": "Antigua-et-Barbuda" },
  { "isoCode2": "SA", "name": "Arabie saoudite" },
  { "isoCode2": "AR", "name": "Argentine" },
  { "isoCode2": "AM", "name": "Arménie" },
  { "isoCode2": "AW", "name": "Aruba" },
  { "isoCode2": "AU", "name": "Australie" },
  { "isoCode2": "AT", "name": "Autriche" },
  { "isoCode2": "AZ", "name": "Azerbaïdjan" },
  { "isoCode2": "BS", "name": "Bahamas" },
  { "isoCode2": "BH", "name": "Bahreïn" },
  { "isoCode2": "BD", "name": "Bangladesh" },
  { "isoCode2": "BB", "name": "Barbade" },
  { "isoCode2": "BE", "name": "Belgique" },
  { "isoCode2": "BZ", "name": "Belize" },
  { "isoCode2": "BJ", "name": "Bénin" },
  { "isoCode2": "BM", "name": "Bermudes" },
  { "isoCode2": "BT", "name": "Bhoutan" },
  { "isoCode2": "BY", "name": "Biélorussie" },
  { "isoCode2": "BO", "name": "Bolivie" },
  { "isoCode2": "BA", "name": "Bosnie-Herzégovine" },
  { "isoCode2": "BW", "name": "Botswana" },
  { "isoCode2": "BR", "name": "Brésil" },
  { "isoCode2": "BN", "name": "Brunéi Darussalam" },
  { "isoCode2": "BG", "name": "Bulgarie" },
  { "isoCode2": "BF", "name": "Burkina Faso" },
  { "isoCode2": "BI", "name": "Burundi" },
  { "isoCode2": "KH", "name": "Cambodge" },
  { "isoCode2": "CM", "name": "Cameroun" },
  { "isoCode2": "CA", "name": "Canada" },
  { "isoCode2": "CV", "name": "Cap-Vert" },
  { "isoCode2": "CL", "name": "Chili" },
  { "isoCode2": "CN", "name": "Chine" },
  { "isoCode2": "CY", "name": "Chypre" },
  { "isoCode2": "CO", "name": "Colombie" },
  { "isoCode2": "KM", "name": "Comores" },
  { "isoCode2": "CG", "name": "Congo-Brazzaville" },
  { "isoCode2": "CD", "name": "Congo-Kinshasa" },
  { "isoCode2": "KP", "name": "Corée du Nord" },
  { "isoCode2": "KR", "name": "Corée du Sud" },
  { "isoCode2": "CR", "name": "Costa Rica" },
  { "isoCode2": "CI", "name": "Côte d'Ivoire" },
  { "isoCode2": "HR", "name": "Croatie" },
  { "isoCode2": "CU", "name": "Cuba" },
  { "isoCode2": "DK", "name": "Danemark" },
  { "isoCode2": "DJ", "name": "Djibouti" },
  { "isoCode2": "DM", "name": "Dominique" },
  { "isoCode2": "EG", "name": "Égypte" },
  { "isoCode2": "SV", "name": "El Salvador" },
  { "isoCode2": "AE", "name": "Émirats arabes unis" },
  { "isoCode2": "EC", "name": "Équateur" },
  { "isoCode2": "ER", "name": "Érythrée" },
  { "isoCode2": "ES", "name": "Espagne" },
  { "isoCode2": "EE", "name": "Estonie" },
  { "isoCode2": "US", "name": "États-Unis" },
  { "isoCode2": "ET", "name": "Éthiopie" },
  { "isoCode2": "FJ", "name": "Fidji" },
  { "isoCode2": "FI", "name": "Finlande" },
  { "isoCode2": "FR", "name": "France" },
  { "isoCode2": "GA", "name": "Gabon" },
  { "isoCode2": "GM", "name": "Gambie" },
  { "isoCode2": "GE", "name": "Géorgie" },
  { "isoCode2": "GH", "name": "Ghana" },
  { "isoCode2": "GI", "name": "Gibraltar" },
  { "isoCode2": "GR", "name": "Grèce" },
  { "isoCode2": "GD", "name": "Grenade" },
  { "isoCode2": "GL", "name": "Groenland" },
  { "isoCode2": "GP", "name": "Guadeloupe" },
  { "isoCode2": "GU", "name": "Guam" },
  { "isoCode2": "GT", "name": "Guatemala" },
  { "isoCode2": "GN", "name": "Guinée" },
  { "isoCode2": "GQ", "name": "Guinée équatoriale" },
  { "isoCode2": "GW", "name": "Guinée-Bissau" },
  { "isoCode2": "GY", "name": "Guyana" },
  { "isoCode2": "GF", "name": "Guyane française" },
  { "isoCode2": "HT", "name": "Haïti" },
  { "isoCode2": "HN", "name": "Honduras" },
  { "isoCode2": "HK", "name": "Hong Kong" },
  { "isoCode2": "HU", "name": "Hongrie" },
  { "isoCode2": "IN", "name": "Inde" },
  { "isoCode2": "ID", "name": "Indonésie" },
  { "isoCode2": "IQ", "name": "Irak" },
  { "isoCode2": "IR", "name": "Iran" },
  { "isoCode2": "IE", "name": "Irlande" },
  { "isoCode2": "IS", "name": "Islande" },
  { "isoCode2": "IL", "name": "Israël" },
  { "isoCode2": "IT", "name": "Italie" },
  { "isoCode2": "JM", "name": "Jamaïque" },
  { "isoCode2": "JP", "name": "Japon" },
  { "isoCode2": "JO", "name": "Jordanie" },
  { "isoCode2": "KZ", "name": "Kazakhstan" },
  { "isoCode2": "KE", "name": "Kenya" },
  { "isoCode2": "KG", "name": "Kirghizistan" },
  { "isoCode2": "KI", "name": "Kiribati" },
  { "isoCode2": "KW", "name": "Koweït" },
  { "isoCode2": "LA", "name": "Laos" },
  { "isoCode2": "LS", "name": "Lesotho" },
  { "isoCode2": "LV", "name": "Lettonie" },
  { "isoCode2": "LB", "name": "Liban" },
  { "isoCode2": "LR", "name": "Libéria" },
  { "isoCode2": "LY", "name": "Libye" },
  { "isoCode2": "LI", "name": "Liechtenstein" },
  { "isoCode2": "LT", "name": "Lituanie" },
  { "isoCode2": "LU", "name": "Luxembourg" },
  { "isoCode2": "MO", "name": "Macao" },
  { "isoCode2": "MK", "name": "Macédoine du Nord" },
  { "isoCode2": "MG", "name": "Madagascar" },
  { "isoCode2": "MY", "name": "Malaisie" },
  { "isoCode2": "MW", "name": "Malawi" },
  { "isoCode2": "MV", "name": "Maldives" },
  { "isoCode2": "ML", "name": "Mali" },
  { "isoCode2": "MT", "name": "Malte" },
  { "isoCode2": "MA", "name": "Maroc" },
  { "isoCode2": "MQ", "name": "Martinique" },
  { "isoCode2": "MU", "name": "Maurice" },
  { "isoCode2": "MR", "name": "Mauritanie" },
  { "isoCode2": "YT", "name": "Mayotte" },
  { "isoCode2": "MX", "name": "Mexique" },
  { "isoCode2": "MD", "name": "Moldavie" },
  { "isoCode2": "MC", "name": "Monaco" },
  { "isoCode2": "MN", "name": "Mongolie" },
  { "isoCode2": "ME", "name": "Monténégro" },
  { "isoCode2": "MS", "name": "Montserrat" },
  { "isoCode2": "MZ", "name": "Mozambique" },
  { "isoCode2": "MM", "name": "Myanmar" },
  { "isoCode2": "NA", "name": "Namibie" },
  { "isoCode2": "NR", "name": "Nauru" },
  { "isoCode2": "NP", "name": "Népal" },
  { "isoCode2": "NI", "name": "Nicaragua" },
  { "isoCode2": "NE", "name": "Niger" },
  { "isoCode2": "NG", "name": "Nigéria" },
  { "isoCode2": "NU", "name": "Niue" },
  { "isoCode2": "NO", "name": "Norvège" },
  { "isoCode2": "NC", "name": "Nouvelle-Calédonie" },
  { "isoCode2": "NZ", "name": "Nouvelle-Zélande" },
  { "isoCode2": "OM", "name": "Oman" },
  { "isoCode2": "UG", "name": "Ouganda" },
  { "isoCode2": "UZ", "name": "Ouzbékistan" },
  { "isoCode2": "PK", "name": "Pakistan" },
  { "isoCode2": "PW", "name": "Palaos" },
  { "isoCode2": "PS", "name": "Palestine" },
  { "isoCode2": "PA", "name": "Panama" },
  { "isoCode2": "PG", "name": "Papouasie-Nouvelle-Guinée" },
  { "isoCode2": "PY", "name": "Paraguay" },
  { "isoCode2": "NL", "name": "Pays-Bas" },
  { "isoCode2": "PE", "name": "Pérou" },
  { "isoCode2": "PH", "name": "Philippines" },
  { "isoCode2": "PL", "name": "Pologne" },
  { "isoCode2": "PF", "name": "Polynésie française" },
  { "isoCode2": "PR", "name": "Porto Rico" },
  { "isoCode2": "PT", "name": "Portugal" },
  { "isoCode2": "QA", "name": "Qatar" },
  { "isoCode2": "RE", "name": "Réunion" },
  { "isoCode2": "RO", "name": "Roumanie" },
  { "isoCode2": "GB", "name": "Royaume-Uni" },
  { "isoCode2": "RU", "name": "Russie" },
  { "isoCode2": "RW", "name": "Rwanda" },
  { "isoCode2": "EH", "name": "Sahara occidental" },
  { "isoCode2": "KN", "name": "Saint-Kitts-et-Nevis" },
  { "isoCode2": "SM", "name": "Saint-Marin" },
  { "isoCode2": "PM", "name": "Saint-Pierre-et-Miquelon" },
  { "isoCode2": "VC", "name": "Saint-Vincent-et-les Grenadines" },
  { "isoCode2": "SH", "name": "Sainte-Hélène" },
  { "isoCode2": "LC", "name": "Sainte-Lucie" },
  { "isoCode2": "WS", "name": "Samoa" },
  { "isoCode2": "AS", "name": "Samoa américaines" },
  { "isoCode2": "ST", "name": "Sao Tomé-et-Principe" },
  { "isoCode2": "SN", "name": "Sénégal" },
  { "isoCode2": "RS", "name": "Serbie" },
  { "isoCode2": "SC", "name": "Seychelles" },
  { "isoCode2": "SL", "name": "Sierra Leone" },
  { "isoCode2": "SG", "name": "Singapour" },
  { "isoCode2": "SK", "name": "Slovaquie" },
  { "isoCode2": "SI", "name": "Slovénie" },
  { "isoCode2": "SO", "name": "Somalie" },
  { "isoCode2": "SD", "name": "Soudan" },
  { "isoCode2": "SS", "name": "Soudan du Sud" },
  { "isoCode2": "LK", "name": "Sri Lanka" },
  { "isoCode2": "SE", "name": "Suède" },
  { "isoCode2": "CH", "name": "Suisse" },
  { "isoCode2": "SR", "name": "Suriname" },
  { "isoCode2": "SZ", "name": "Eswatini" },
  { "isoCode2": "SY", "name": "Syrie" },
  { "isoCode2": "TJ", "name": "Tadjikistan" },
  { "isoCode2": "TW", "name": "Taïwan" },
  { "isoCode2": "TZ", "name": "Tanzanie" },
  { "isoCode2": "TD", "name": "Tchad" },
  { "isoCode2": "CZ", "name": "Tchéquie" },
  { "isoCode2": "TH", "name": "Thaïlande" },
  { "isoCode2": "TL", "name": "Timor oriental" },
  { "isoCode2": "TG", "name": "Togo" },
  { "isoCode2": "TK", "name": "Tokelau" },
  { "isoCode2": "TO", "name": "Tonga" },
  { "isoCode2": "TT", "name": "Trinité-et-Tobago" },
  { "isoCode2": "TN", "name": "Tunisie" },
  { "isoCode2": "TM", "name": "Turkménistan" },
  { "isoCode2": "TR", "name": "Turquie" },
  { "isoCode2": "TV", "name": "Tuvalu" },
  { "isoCode2": "UA", "name": "Ukraine" },
  { "isoCode2": "UY", "name": "Uruguay" },
  { "isoCode2": "VU", "name": "Vanuatu" },
  { "isoCode2": "VA", "name": "Vatican" },
  { "isoCode2": "VE", "name": "Venezuela" },
  { "isoCode2": "VN", "name": "Vietnam" },
  { "isoCode2": "WF", "name": "Wallis-et-Futuna" },
  { "isoCode2": "YE", "name": "Yémen" },
  { "isoCode2": "ZM", "name": "Zambie" },
  { "isoCode2": "ZW", "name": "Zimbabwe" }
] ,
  PAYMENT_NETWORKS: new Map<string, PaymentNetwork[]>([  
    [ 
    "SN",[
    {
        code:'CASHXOF',
        label:'Espèces',
        isMobileMoney:false,
        logo:'images/cash.png',
        mode:'CASH',
        contexts:['cashier']
    },
    {
        code:'OMSN',
        label:'Orange Money',
        isMobileMoney:true,
        logo:'images/omsn.webp',
        mode:'WALLET'
    },
    
    {
        code:'WVSN',
        label:'Wave',
        isMobileMoney:true,
        logo:'images/wave-logo.webp',
        mode:'WALLET'
    },
  
    {
        code:'CARD',
        label:'Carte Bancaire',
        logo:'images/visamaster.png',
        isMobileMoney:false,
        mode:'CARD'
    }]
],
    [ "CI",[
   {
        code:'CARD',
        label:'Carte Bancaire',
        logo:'images/visamaster.png',
        isMobileMoney:false,
        mode:'CARD'
    },
    
    {
        code:'WVCI',
        label:'Wave',
        isMobileMoney:true,
        logo:'images/wave-logo.webp',
        mode:'WALLET'
    },
    {
        code:'MTNCI',
        label:'MTN',
        isMobileMoney:true,
        logo:'images/mtn.png',
        mode:'WALLET'
    }]

    ]
]),
    getPaymentNetworks(countryCode: string, context?: string): PaymentNetwork[] {
        const networks = this.PAYMENT_NETWORKS.get(countryCode) ?? [];
        if (!context) return networks.filter(n => !n.contexts || n.contexts.length === 0);
        return networks.filter(n => !n.contexts || n.contexts.includes(context));
    }
}
  